<aside
  class="container container-style-primary"
  [class.trimmed]="(uiService.screenSize === 'Large' || uiService.screenSize === 'XLarge' || uiService.screenSize === 'Unknown') && uiService.uiState().chat === 'trimmed'"
>
  <app-chat-top-bar></app-chat-top-bar>
  <app-chat-messages></app-chat-messages>
  @if (chatService.triviaRain?.current) {
  <app-chat-trivia-rain></app-chat-trivia-rain>
  } @if (chatService.trivia?.current) {
  <app-chat-trivia></app-chat-trivia>
  }
  <div class="bottom" [class.trimmed]="uiService.uiState().chat === 'trimmed'">
    <app-sign-in-block class="container-style-primary"></app-sign-in-block>
    @if (session.profile()) {
    <app-chat-bottom class="bottom" [message]="chatService.message"></app-chat-bottom>
    }
  </div>
</aside>
